import React from 'react';
import { FormControl, InputLabel } from '@mui/material';
import { householdFilterLabelSx } from '../utils/personalFinancesHousehold';

type Props = {
  label: string;
  minWidth: number;
  testId?: string;
  children: React.ReactElement<{ labelId?: string; notched?: boolean }>;
};

/** Outlined Select with a static caption above the field instead of a floating notch label. */
export const HouseholdFilterField: React.FC<Props> = ({ label, minWidth, testId, children }) => {
  const labelId = testId ? `${testId}-label` : undefined;
  return (
    <FormControl
      size="small"
      sx={{ minWidth, '& .MuiOutlinedInput-notchedOutline legend': { width: 0 } }}
      data-testid={testId}
    >
      <InputLabel id={labelId} shrink disableAnimation sx={householdFilterLabelSx}>
        {label}
      </InputLabel>
      {React.cloneElement(children, { labelId, notched: false })}
    </FormControl>
  );
};
